import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import filter from 'lodash/filter';
import slice from 'lodash/slice';
import { ArrowUp } from '@yme/assets/icons';
import { DestinationLogo } from '@yme/assets/icons/destinations';
import { SVG } from '@yme/atoms/svg-icon';
import { NavListMobile } from '@yme/components/Header/PageLevelNavigation/NavListMobile';
import { Link } from '@yme/components/Link';
import { getUrlWithTestRideMode } from '@yme/organisms/test-ride-grid/helpers';
import { useQueryParams } from '@yme/organisms/test-ride-grid/useQueryParams';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel4 } from '@yme/tokens/typography';
import { ImageWrapperStyled, NavItemStyled, NavLinkStyled, NavListStyled, NavTitleIconStyled, NavTitleStyled, UpButtonStyled, } from './styled';
export function NavList({ title, pageLevelNavigationItems, upButton, trackNavigation, isDestinationPage, isRightToLeft, }) {
    const [hiddenDropdownItems, setHiddenDropdownItems] = useState([]);
    const containerRef = useRef(null);
    const { t } = useTranslation();
    const { getQueryParams } = useQueryParams({});
    const { dealerId, isIframe } = getQueryParams();
    const link = useMemo(() => {
        if (upButton) {
            return getUrlWithTestRideMode({
                url: upButton.link,
                dealerId,
                isIframe,
            });
        }
        return '';
    }, [upButton, dealerId, isIframe]);
    const checkItemsSize = useCallback(() => {
        const container = containerRef.current;
        const items = container?.children;
        if (container && items) {
            const containerBottom = container.getBoundingClientRect().bottom;
            const visibleItemsTemp = filter(Array.from(items), (item) => item.getBoundingClientRect().bottom <= containerBottom);
            setHiddenDropdownItems(slice(pageLevelNavigationItems, visibleItemsTemp.length));
        }
    }, [pageLevelNavigationItems]);
    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (containerRef.current) {
                checkItemsSize();
            }
        });
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }
        return () => {
            resizeObserver.disconnect();
        };
    }, [checkItemsSize]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FlexWrapper, { alignItems: "center", pr: "117px", isRightToLeft: isRightToLeft },
            upButton && !isDestinationPage && (React.createElement(React.Fragment, null,
                React.createElement(UpButtonStyled, null,
                    React.createElement(Link, { to: link, onClick: trackNavigation(link, 'breadcrumb') },
                        React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, upButton?.title))),
                React.createElement(NavTitleIconStyled, { pathFill: colorCoreWhite1000, type: ArrowUp, iconRotate: isRightToLeft ? 270 : 90 }))),
            isDestinationPage ? (React.createElement(ImageWrapperStyled, null,
                React.createElement(SVG, { src: DestinationLogo }))) : (React.createElement(NavTitleStyled, null,
                React.createElement(HeadingLevel4, { color: colorCoreWhite1000 }, title)))),
        React.createElement(FlexWrapper, { flex: "1", alignItems: "center" },
            Boolean(pageLevelNavigationItems.length) && (React.createElement(NavListStyled, { isRightToLeft: isRightToLeft, ref: containerRef }, pageLevelNavigationItems.map(({ title: navTitle, link, isCurrent }) => (React.createElement(NavItemStyled, { key: navTitle, isRightToLeft: isRightToLeft },
                React.createElement(NavLinkStyled, { to: link, isActive: isCurrent, onClick: trackNavigation(link) }, navTitle)))))),
            Boolean(hiddenDropdownItems.length) && (React.createElement(NavListMobile, { title: t('common_more_label'), pageLevelNavigationItems: hiddenDropdownItems, isRightToLeft: isRightToLeft, trackNavigation: trackNavigation })))));
}
